export default () => {
    const ctaBlock = document.querySelector('.call-to-action-block-right');
    if (!ctaBlock)
        return;
    import(/* webpackChunkName: "CTABlock" */ "./../classes/ctaBlockAnimationClass")
        .then(({ default: CtaBlock }) => {
        new CtaBlock(ctaBlock);
    })
        .catch(() => "An error with CTA Block Module occurred");
};
